<template>
<div class="news">
    <publicHead :background="bg" title="新闻中心" en-title="NEWS CENTER" @check="check" :list="['企业新闻','技术动态']" :active="active" />
    <div class="wrap">
        <company v-show="active == 0" />
        <instory v-show="active == 1" />
    </div>
</div>
</template>

<script>
import company from '@/components/news/company'
import instory from '@/components/news/instory'
export default {
    components: {
        company,
        instory
    },
    data() {
        return {
            bg: require("../assets/img/news-head.png"),
            active: 0,
        };
    },
    created() {
        if (this.$route.query.type) {
            this.active = this.$route.query.type
        }
    },
    methods: {
        check(e) {
            this.active = e;
            console.log(e)
        },
    },
};
</script>

<style lang="less" scoped>
.news {
    background-color: rgb(246, 246, 246);
}

.wrap {
    padding: 0 .3rem;
    padding-top: 0.43rem;
    margin-top: 1.05rem;
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(29, 62, 85, 0.14);
    box-sizing: border-box;
}
</style>
